export default "__VITE_ASSET__stitsChn__"